import type { Worker } from "@src/appV2/Worker/api/types";
import { type ReactElement } from "react";

import { PageWrapper } from "../../components/PageWrapper";
import { OnboardingPageHeader } from "../SharedPageHeader";
import { type OnboardingStage } from "../util/constants";
import { useSaveOnboardingStageEffect } from "./useSaveOnboardingStageEffect";

export interface OnboardingStepProps {
  onNext: () => Promise<void> | void;
  stage: OnboardingStage;
  worker: Worker | undefined;
}

export interface OnboardingStepWrapperProps extends OnboardingStepProps {
  worker: Worker | undefined;
  progress: {
    current: number;
    total: number;
  };
  render: (props: OnboardingStepProps) => ReactElement;
  onBack: () => Promise<void> | void;
}

/**
 * Base component for all onboarding steps.
 * - Ensures the stage is updated
 * - Ensures step have a common header UI with progress bar and back button
 * @param props
 * @returns
 */
export function OnboardingStepWrapper(props: OnboardingStepWrapperProps): ReactElement {
  const { onBack, progress, onNext, render, stage, worker } = props;
  useSaveOnboardingStageEffect({ worker, stage });

  return (
    <PageWrapper variant="tertiary">
      <OnboardingPageHeader progress={progress} onClickBack={onBack} />
      {render({ onNext, stage, worker })}
    </PageWrapper>
  );
}
